import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getGameDetails } from "../api/getGameDetails";

export const useGameDetailsQuery = (gameId: string) => {
  return useQuery({
    queryKey: ["gameDetails", gameId],
    queryFn: async () => {
      return await getGameDetails(gameId);
    },
    staleTime: 0,
    enabled: !!gameId,
  });
};

export const invalidateGameDetailsQuery = (gameId: string) => {
  return queryClient.invalidateQueries({ queryKey: ["gameDetails", gameId] });
};

export const invalidateEntireGamesDetailsQuery = () => {
  return queryClient.invalidateQueries({ queryKey: ["gameDetails"] });
};
